import * as yup from "yup";

export const T3SlipSettingValidation = yup.object().shape({
  transmitter: yup.string().required("Transmitter is required"),
  nameOfTrust: yup.string().required("Name of Trust is required"),
  trustAccountNumber: yup.string().required("Trust Account # is required"),
  trusteeFirstName: yup.string().required("Trustee First Name is required"),
  trusteeLastName: yup.string().required("Trustee Last Name is required"),
  t3Province: yup.string().required("Province is required"),
});
